import { Step, StepLabel, Stepper } from "@mui/material"
import { theme } from "@op-str/op-component-library"
import React from "react"
import styled from "styled-components"
import { ServicePageBanner } from "../../types/ServicePageBanner"
import { ServiceBannerStep } from "../ServiceBannerStep"

export type ServiceBannerStepperProps = {
  servicePage?: ServicePageBanner
}

export const ServiceBannerStepper = (props: ServiceBannerStepperProps) => {
  const { servicePage } = props

  if (!servicePage) return null

  return (
    <BannerStepper alternativeLabel activeStep={servicePage.steps.length}>
      {servicePage.steps.map((step, index) => (
        <Step key={`service-page-step-${index}`}>
          <BannerStepLabel
            StepIconComponent={ServiceBannerStep}
            StepIconProps={{ icon: <BannerStepperIcon src={step.icon} /> }}
          >
            {step.label}
          </BannerStepLabel>
        </Step>
      ))}
    </BannerStepper>
  )
}

const BannerStepper = styled(Stepper)`
  width: 50%;
  background-color: inherit;
  margin-top: ${theme.spacing.lx};
  padding: 0;

  .MuiStepConnector-alternativeLabel {
    top: 19px;
    right: 100%;
    left: calc(-100% + 40px);
  }

  .MuiStep-horizontal {
    padding: 0;
  }

  .MuiStepConnector-line {
    background-color: ${theme.color.primary100};
    border-color: ${theme.color.primary100};
    height: 3px;
  }
`

const BannerStepLabel = styled(StepLabel)`
  align-items: flex-start;

  .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
    margin-top: ${theme.spacing.m};
    padding-right: ${theme.spacing.l};
    text-align: start;
  }
`

const BannerStepperIcon = styled.img``
